// CSS-only crisis overlay shown when the assistant calls flag_safety_event.
// Non-blocking: the assistant's spoken safety response continues playing.
import { Phone, AlertCircle, X } from "lucide-react";

export default function CrisisOverlay({ open, onDismiss }) {
  if (!open) return null;
  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="crisis-title"
      data-testid="crisis-overlay"
      className="fixed inset-0 z-[90] flex items-end justify-center sm:items-center"
    >
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 50% 0%, hsla(0,55%,55%,0.25), transparent 60%), linear-gradient(180deg, hsla(36,12%,14%,0.55), hsla(36,12%,14%,0.7))",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
        }}
      />
      <div
        className="relative z-10 w-full max-w-md cg-card cg-fade-up rounded-t-[2rem] sm:rounded-[2rem] p-7"
        style={{ boxShadow: "0 30px 80px -30px hsla(36,10%,9%,0.5)" }}
      >
        <div className="mb-3 flex items-start gap-3">
          <span
            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full"
            style={{ background: "hsla(0,55%,55%,0.15)", color: "hsl(0 65% 42%)" }}
          >
            <AlertCircle className="h-5 w-5" strokeWidth={1.7} />
          </span>
          <div className="flex-1">
            <h2
              id="crisis-title"
              className="font-serif-display text-foreground"
              style={{ fontSize: "clamp(1.5rem, 4.5vw, 2rem)" }}
            >
              Please reach for help now.
            </h2>
            <p className="mt-3 text-[15px] leading-7 text-foreground/90">
              If you are in immediate danger, call your local emergency services.
              In the US, call or text <strong>988</strong> for the Suicide and Crisis
              Lifeline. Please also reach one trusted person nearby.
            </p>
          </div>
          <button
            type="button"
            onClick={onDismiss}
            aria-label="Dismiss"
            data-testid="crisis-close"
            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border"
            style={{
              borderColor: "hsla(38,25%,80%,0.7)",
              color: "hsl(30 9% 30%)",
              background: "hsla(0,0%,100%,0.7)",
            }}
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2">
          <a
            href="tel:988"
            data-testid="crisis-call-988"
            className="cg-btn-primary !min-h-[48px]"
          >
            <Phone className="h-4 w-4" strokeWidth={2} />
            Call or text 988
          </a>
          <a
            href="tel:911"
            data-testid="crisis-call-911"
            className="cg-btn-ghost !min-h-[48px]"
          >
            <Phone className="h-4 w-4" strokeWidth={2} />
            Call 911
          </a>
        </div>

        <button
          type="button"
          onClick={onDismiss}
          data-testid="crisis-continue"
          className="mt-4 w-full text-sm text-muted-foreground underline underline-offset-4 transition-colors hover:text-foreground"
        >
          Continue talking
        </button>
      </div>
    </div>
  );
}
